/* eslint-disable */
import React from 'react'
import ReactDOM from 'react-dom'
// import Issues from './components/Issues'
// import Pillar from './components/Pillar'
const { render } = wp.element;

function App() {
  return (
    <div className="filters">
      <Issues />
      <Pillar />
    </div>
    );
}

// import { BrowserRouter, Route, Routes } from 'react-router-dom';


export default App;

render(<App/>, document.getElementById('root'));
/* eslint-enable */

/** 
 * Load React Components
 */
const REACT_COMPONENTS = [
  // {
  //   'selector' : 'issues',
  //   'element' : Issues,
  // },
  // {
  //   'selector' : 'pillar',
  //   'element' : Pillar,
  // },
]

REACT_COMPONENTS.forEach((component) => {
  if(document.querySelector(component.selector)) {
    document.querySelectorAll(component.selector).forEach((item) => {
      ReactDOM.render(
        React.createElement(component.element, item.dataset, null),
        item
      )
    })
  }
})


// WEBPACK FOOTER //
// ./scripts/app.js